<app-loader></app-loader>


<!-- Back Button & Title -->
<div class="flex items-center mt-4">
  <button (click)="back()" class="flex items-center gap-2 text-[#2ee4e8] px-4 py-2 rounded-xl shadow-md">
    <svg fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="#2ee4e8" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
    Back
  </button>
</div>

<div class="p-6 flex flex-col gap-6 pt-2 pb-0">


  <!-- Banner -->
  <div class="relative rounded-3xl overflow-hidden shadow-2xl w-full mx-auto border border-[#2ee4e8]/30">

    <!-- Banner Image -->
    <img src="/banner.png" alt="Lottery Banner" class="w-full h-[160px] sm:h-[200px] md:h-[260px] object-cover">

    <!-- Left Overlay Column -->
    <div class="absolute top-3 sm:top-6 left-3 sm:left-6 flex flex-col gap-2 sm:gap-3 p-2 sm:p-3">

      <!-- Golden Draw Badge -->
      <div class="flex justify-center items-center">

        <div class="inline-flex flex-col items-center gap-2 sm:gap-3
           px-3 sm:px-6 py-2 sm:py-4
           rounded-2xl backdrop-blur-md
           bg-white/10 border border-white/20
           shadow-[0_4px_20px_rgba(0,0,0,0.5)]">

          <!-- Lottery Name -->
          <div class="text-white font-semibold text-[11px] sm:text-sm md:text-base tracking-wide">
            {{ lotteryData?.LotteryName | uppercase }}
          </div>

          <!-- Ticket Price -->
          <h2 class="text-[20px] sm:text-2xl md:text-3xl font-extrabold
               text-transparent bg-clip-text
               bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-600
               drop-shadow-[2px_2px_4px_rgba(0,0,0,0.5)]">
            ${{ lotteryData?.TicketPrice }}
          </h2>

          <!-- Countdown -->
          <div *ngIf="countdownTime" class="flex items-center gap-1 sm:gap-2
             border border-white/20
             bg-black/40 backdrop-blur-sm
             px-2 sm:px-4 py-1 sm:py-2  
             rounded-lg">

            <div class="flex flex-col items-center gap-1">

              <!-- Heading -->
              <span class="text-[9px] sm:text-xs uppercase tracking-widest text-white/70 font-semibold">
                Time Left
              </span>

              <!-- Timer -->
              <div class="flex items-center gap-1 sm:gap-2 md:gap-3
                    text-white font-mono font-bold
                    text-[13px] sm:text-lg md:text-xl">

                <div class="px-1 sm:px-2">{{ countdownTime.hh }}</div>
                <span class="opacity-70">:</span>
                <div class="px-1 sm:px-2">{{ countdownTime.mm }}</div>
                <span class="opacity-70">:</span>
                <div class="px-1 sm:px-2">{{ countdownTime.ss }}</div>

              </div>

            </div>
          </div>

        </div>

      </div>

    </div>
  </div>



  <!-- Ticket Numbers + Selected Numbers -->
  <div class="flex flex-col lg:flex-row gap-6 w-full max-w-full mx-auto">

    <!-- Ticket Numbers -->
    <div class="flex-1 bg-[#0e1522] border border-[#2ee4e8]/40 rounded-2xl shadow-xl p-6">
      <div class="flex justify-between items-center">
        <h2 class="text-white text-lg font-bold">Ticket Numbers</h2>
        <button (click)="clearAll()"
          class="px-3 py-1 bg-transparent border border-[#2ee4e8] text-[#2ee4e8] rounded hover:bg-[#2ee4e8] hover:text-black transition">
          Clear All
        </button>
      </div>

      <!-- Number Grid -->
      <div class="grid grid-cols-5 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-12 gap-3 mt-4">
        <button *ngFor="let number of numbers" (click)="toggleNumber(number)"
          [disabled]="purchasedNumbers.includes(number)" [ngClass]="{
          'bg-red-600 text-white border border-red-400 cursor-not-allowed': purchasedNumbers.includes(number),
          'bg-[#2ee4e8] text-black font-bold shadow-md': isSelected(number) && !purchasedNumbers.includes(number),
          'bg-[#1a2537] text-white border border-gray-600 hover:bg-[#2a364a]': !isSelected(number) && !purchasedNumbers.includes(number)
        }" class="w-10 h-10 rounded-md text-sm transition duration-200 flex items-center justify-center">
          {{ number }}
        </button>
      </div>
    </div>

    <!-- Selected Numbers -->
    <!-- Selected Numbers -->
    <div class="flex-1 bg-[#0e1522] border border-[#2ee4e8]/40 rounded-2xl shadow-xl p-6 flex flex-col">
      <h2 class="text-white text-lg font-bold mb-4">Selected Numbers</h2>

      <!-- Numbers List -->
      <div class="flex flex-wrap gap-2 mb-6">
        <div *ngFor="let number of selectedNumbers" class="relative">
          <span
            class="px-3 py-2 bg-[#2ee4e8] text-black font-semibold rounded-md shadow text-sm cursor-pointer hover:opacity-90">
            {{ number }}
          </span>
          <span (click)="removeSelectedNumber(number)"
            class="absolute -top-2 -right-2 bg-black text-white text-xs rounded-full w-5 h-5 flex items-center justify-center cursor-pointer hover:bg-red-500 transition">
            ✕
          </span>
        </div>

        <span *ngIf="selectedNumbers.length === 0" class="text-gray-400 text-sm italic">
          No numbers selected
        </span>
      </div>

      <!-- Price + Buy Button (always bottom) -->
      <div
        class="mt-auto bg-[#2ee4e8]/10 border border-[#2ee4e8]/40 rounded-xl p-4 flex justify-between items-center shadow">
        <div>
          <p class="text-gray-300 text-sm">Your total ticket price</p>
          <p class="text-2xl font-bold text-white">${{ totalAmount.toFixed(2) }}</p>
        </div>
        <button (click)="buyTicket()" class="px-6 py-3  text-black font-semibold rounded-xl shadow --button">
          Buy Ticket
        </button>
      </div>
    </div>

  </div>


  <!-- ✅ Success Modal -->
  <div *ngIf="showSuccessModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="absolute inset-0 bg-black/60" (click)="closeSuccessModal()" aria-hidden="true"></div>
    <div class="relative bg-[#181d2e] border border-[#2ee4e8] rounded-2xl p-6 w-[90vw] max-w-md shadow-2xl text-center">
      <button class="absolute -right-1 top-3 text-[#2ee4e8] w-12 text-2xl" (click)="closeSuccessModal()"
        aria-label="Close">&times;</button>

      <div
        class="mx-auto mb-3 h-12 w-12 rounded-full bg-green-400/30 border border-green-300 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-400" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l2.9 6.3 6.9.6-5.2 4.6 1.6 6.8-6.2-3.7-6.2 3.7 1.6-6.8-5.2-4.6 6.9-.6L12 2z" />
          <path d="M9 12l2 2l4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

      </div>

      <h3 class="text-yellow-400 text-xl font-extrabold mb-1">Congratulations!</h3>
      <p class="text-purple-200 text-sm mb-5">Your ticket purchase was successful! Good luck ✨</p>

      <div class="flex items-center justify-center gap-2">
        <button class="px-4 py-2 rounded-xl border border-gray-500 text-black font-semibold" style="background: #2ee4e8"
          (click)="goToMyTickets()">
          View Tickets
        </button>
      </div>
    </div>
  </div>
</div>